import { Card, Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions } from './WorkOrderReference.redux';
import LoadingCover from '../../../components/LoadingCover/LoadingCover';
import SearchWorkOrders from '../SearchWorkOrders';
import { useParams } from 'react-router-dom';
import WorkOrderSNAllocationButton from './WorkOrderMultiSerialNumber/WorkOrderSNAllocationButton';

const WorkOrderHeader = () => {
	const dispatch         = useDispatch(),
		  params           = useParams(),
		  docNum           = params.docNum,
		  workOrderHeader  = useSelector(state => state.workOrderReference.workOrderHeader),
		  headerLoading    = useSelector(state => state.workOrderReference.headerLoading),
		  allocatingSNs    = useSelector(state => state.workOrderSerialNum.allocatingSNs);
	
	
	useEffect(() => {
		if (docNum) {
			dispatch(actions.loadWorkOrderHeader(docNum));
		}
	}, [ dispatch, docNum ]);

    return (
		<Card
			className="ts_portal_card ts-portal-card-margin .ts_portal_form_item
	label
		font-weight: bold ts_full_width ts_fixed_height"
			title="Search by Work Order"
		>

			{
				(headerLoading || allocatingSNs) &&
				<LoadingCover />
			}

			<SearchWorkOrders />

			{
				workOrderHeader.DocNum &&
				<>
					<WorkOrderSNAllocationButton />

					<Row
						className="ts_margin_top"
						gutter={{
							xs: 8,
							sm: 16,
							md: 24,
							lg: 32,
						}}
					>
						<Col
							flex="auto"
						>
							<h2>Order #: {workOrderHeader.DocNum}</h2>
							<h2>PO #: {workOrderHeader.U_TS_SubConPOReference}</h2>
							<h2>Status: {workOrderHeader.Status}</h2>
							<h2>Part Info: {workOrderHeader.PartInfo} </h2>
						</Col>
						
						<Col 
							flex="auto"
						>
							<h2>Quantity: {workOrderHeader.PlannedQty}</h2>
							<h2>Project: {workOrderHeader.Project}</h2>
							<h2>Due Date: {workOrderHeader.DueDate}</h2>
						</Col>

						<Col 
							flex="auto"
						>
							<h2>Serial #: {workOrderHeader.SerialNumber}</h2>
							<h2>Revision: {workOrderHeader.Revision}</h2>
							<h2>Production Order Type: {workOrderHeader.ProdType}</h2>
						</Col>
					</Row>
				</>
			}

		</Card>
                
    );
};

export default WorkOrderHeader;
